import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "nav_submit": "Submit Ticket",
      "nav_follow": "Follow Up",
      "nav_overview": "Overview",
      "nav_tickets": "Tickets",
      "nav_users": "Users",
      "nav_config": "Configuration",
      "nav_profile": "Profile",
      "nav_login": "Agent Login",
      "nav_logout": "Logout",
      "dashboard_title": "Dashboard Overview",
      "status_new": "New",
      "status_open": "Open",
      "status_in_progress": "In Progress",
      "status_resolved": "Resolved",
      "status_closed": "Closed",
      "priority_high": "High",
      "priority_medium": "Medium",
      "priority_low": "Low",
      "search_placeholder": "Search title or email...",
      "profile_title": "My Profile",
      "profile_first_name": "First Name",
      "profile_last_name": "Last Name",
      "profile_language": "Preferred Language",
      "profile_save": "Save Changes",
      "profile_success": "Profile updated successfully",
      "profile_logs_title": "Action History",
      "profile_no_logs": "No actions recorded yet.",
      "profile_page_size": "Records per page",
      "profile_password_success": "Password changed successfully",
      "password_strength": "Password Strength",
      "strength_very_weak": "Very Weak",
      "strength_weak": "Weak",
      "strength_medium": "Medium",
      "strength_strong": "Strong",
      "ticket_update_success": "Changes saved successfully",
      "ticket_note_success": "Internal note added",
      "ticket_email_success": "Email sent successfully",
      "ticket_chat_title": "Conversation",
      "ticket_message_placeholder": "Write a message to the user...",
      "ticket_message_send": "Send Message",
      "reset_filters": "Reset Filters",
      "config_assignment_title": "Ticket Assignment",
      "config_assignment_strategy": "Assignment Strategy",
      "config_assignment_volume": "Volume Balancing (Round Robin)",
      "config_assignment_project": "Project-based Assignment",
      "config_assignment_save": "Save Assignment Settings",
      "config_domains_title": "Allowed Domains",
      "config_domains_help": "Restricts user registration to specific email domains (comma-separated). Leave empty to allow all.",
      "config_domains_placeholder": "example.com, company.org",
      "config_domains_save": "Save Domain Restrictions",
      "config_assignment_help": "Define how the system assigns new tickets to agents.",
      "config_roles_title": "Role Management",
      "config_roles_help": "Create roles and define their access level. Admins have full access by default.",
      "config_functionalities_title": "Functionalities",
      "config_add_project": "Add Project",
      "config_project_name": "Project Name",
      "config_add_functionality": "Add Functionality",
      "form_functionality": "Functionality",
      "form_support_title": "Submit a Support Ticket",
      "form_support_subtitle": "Please fill out the form below to submit your support request.",
      "form_email": "Your Email",
      "form_project": "Project",
      "form_subject": "Subject",
      "form_description": "Description",
      "form_attach_files": "Attach Files",
      "form_drag_drop_msg": "or drag and drop them here",
      "form_drag_drop_active": "Drop files now",
      "form_remove": "Remove",
      "form_submit_ticket": "Submit Ticket",
      "err_title_required": "Title is required.",
      "err_description_required": "Description is required.",
      "err_email_invalid": "Email is not valid.",
      "err_project_required": "Please select a project.",
      "err_file_too_large": "Some files exceed the {{max}}MB limit and were ignored.",
      "err_file_type_invalid_image": "Invalid file type. Only JPG and PNG are allowed.",
      "err_file_type_invalid": "Invalid file type. Only JPG, PNG, PDF, DOCX, and XLSX are allowed.",
      "login_title": "Login to TicSmart",
      "login_email": "Email",
      "login_password": "Password",
      "login_button": "Login",
      "login_forgot_password": "Forgot your password?",
      "login_signup_link": "Don't have an account? Register here",
      "forgot_password_title": "Reset Password",
      "forgot_password_msg": "Enter your email address and we'll send you a link to reset your password.",
      "forgot_password_success": "If the account exists, an email has been sent.",
      "reset_password_title": "Set New Password",
      "reset_password_btn": "Reset Password",
      "reset_password_success": "Password updated successfully. You can now login.",
      "reset_password_error": "The link is invalid or has expired.",
      "reset_password_generate": "Generate Secure Password",
      "login_invalid_credentials": "Invalid credentials. Please try again.",
      "err_404_title": "404 - Page Not Found", // Keep this
      "err_404_msg": "The page you are looking for doesn't exist or has been moved.",
      "err_404_btn": "Back to Home",
      "signup_title": "Create an Account",
      "signup_button": "Register",
      "signup_success": "Registration successful! You can now log in.",
      "signup_login_link": "Already have an account? Log in",
      "signup_first_name": "First Name",
      "signup_last_name": "Last Name",
      "signup_email": "Email Address",
      "signup_password": "Password"
    }
  },
  es: {
    translation: {
      "nav_submit": "Enviar Ticket",
      "nav_follow": "Seguimiento",
      "nav_overview": "Resumen",
      "nav_tickets": "Tickets",
      "nav_users": "Usuarios",
      "nav_config": "Configuración",
      "nav_profile": "Perfil",
      "nav_login": "Acceso Agente",
      "nav_logout": "Cerrar Sesión",
      "dashboard_title": "Panel de Control",
      "status_new": "Nuevo",
      "status_open": "Abierto",
      "status_in_progress": "En Progreso",
      "status_resolved": "Resuelto",
      "status_closed": "Cerrado",
      "priority_high": "Alta",
      "priority_medium": "Media",
      "priority_low": "Baja",
      "search_placeholder": "Buscar título o email...",
      "profile_title": "Mi Perfil",
      "profile_first_name": "Nombre",
      "profile_last_name": "Apellido",
      "profile_language": "Idioma Preferido",
      "profile_save": "Guardar Cambios",
      "profile_success": "Perfil actualizado correctamente",
      "profile_logs_title": "Historial de Acciones",
      "profile_no_logs": "Aún no hay acciones registradas.",
      "profile_page_size": "Registros por página",
      "profile_password_success": "Contraseña cambiada exitosamente",
      "password_strength": "Fuerza de la contraseña",
      "strength_very_weak": "Muy Débil",
      "strength_weak": "Débil",
      "strength_medium": "Media",
      "strength_strong": "Fuerte",
      "ticket_update_success": "Cambios guardados exitosamente",
      "ticket_note_success": "Nota interna añadida",
      "ticket_email_success": "Email enviado correctamente",
      "ticket_chat_title": "Conversación con el Usuario",
      "ticket_message_placeholder": "Escribe un mensaje para el usuario...",
      "ticket_message_send": "Enviar Mensaje",
      "reset_filters": "Reiniciar Filtros",
      "config_assignment_title": "Asignación de Tickets",
      "config_assignment_strategy": "Estrategia de Asignación",
      "config_assignment_volume": "Balanceo por Volumen (Equitativo)",
      "config_assignment_project": "Asignación por Proyecto",
      "config_assignment_save": "Guardar Configuración de Asignación",
      "config_domains_title": "Dominios Permitidos",
      "config_domains_help": "Restringe el registro de usuarios a dominios de correo específicos (separados por coma). Dejar vacío para permitir todos.",
      "config_domains_placeholder": "ejemplo.com, empresa.org",
      "config_domains_save": "Guardar Restricciones de Dominio",
      "config_assignment_help": "Define cómo el sistema asigna automáticamente los nuevos tickets a los agentes.",
      "config_roles_title": "Gestión de Roles",
      "config_roles_help": "Crea roles y define su nivel de acceso. Los administradores tienen acceso total por defecto.",
      "config_functionalities_title": "Funcionalidades",
      "config_add_project": "Agregar Proyecto",
      "config_project_name": "Nombre del Proyecto",
      "config_add_functionality": "Agregar Funcionalidad",
      "form_functionality": "Funcionalidad",
      "form_support_title": "Enviar un Ticket de Soporte",
      "form_support_subtitle": "Por favor, complete el formulario a continuación para enviar su solicitud de soporte.",
      "form_email": "Tu Correo Electrónico",
      "form_project": "Proyecto",
      "form_subject": "Asunto",
      "form_description": "Descripción",
      "form_attach_files": "Adjuntar Archivos",
      "form_drag_drop_msg": "o arrástrelos aquí",
      "form_drag_drop_active": "Suelte los archivos ahora",
      "form_remove": "Quitar",
      "form_submit_ticket": "Enviar Ticket",
      "err_title_required": "El título es obligatorio.",
      "err_description_required": "La descripción es obligatoria.",
      "err_email_invalid": "El correo no es válido.",
      "err_project_required": "Por favor seleccione un proyecto.",
      "err_file_too_large": "Algunos archivos superan el límite de {{max}}MB y fueron ignorados.",
      "err_file_type_invalid_image": "Tipo de archivo no permitido. Solo se permiten imágenes (JPG, PNG).",
      "err_file_type_invalid": "Tipo de archivo no permitido. Solo se permiten JPG, PNG, PDF, DOCX y XLSX.",
      "login_title": "Iniciar Sesión en TicSmart",
      "login_email": "Correo Electrónico",
      "login_password": "Contraseña",
      "login_button": "Acceder",
      "login_forgot_password": "¿Olvidaste tu contraseña?",
      "login_signup_link": "¿No tienes cuenta? Regístrate aquí",
      "forgot_password_title": "Recuperar Contraseña",
      "forgot_password_msg": "Ingresa tu correo y te enviaremos un enlace para restablecer tu cuenta.",
      "forgot_password_success": "Si la cuenta existe, se ha enviado un correo con instrucciones.",
      "reset_password_title": "Nueva Contraseña",
      "reset_password_btn": "Cambiar Contraseña",
      "reset_password_success": "Contraseña actualizada. Ya puedes iniciar sesión.",
      "reset_password_error": "El enlace es inválido o ha expirado.",
      "reset_password_generate": "Generar Contraseña Segura",
      "login_invalid_credentials": "Credenciales inválidas. Intente de nuevo.",
      "err_404_title": "404 - Página no encontrada", // Keep this
      "err_404_msg": "La página que buscas no existe o ha sido movida.",
      "err_404_btn": "Volver al Inicio",
      "signup_title": "Crear una Cuenta",
      "signup_button": "Registrarse",
      "signup_success": "¡Registro exitoso! Ya puedes iniciar sesión.",
      "signup_login_link": "¿Ya tienes una cuenta? Inicia sesión",
      "signup_first_name": "Nombre",
      "signup_last_name": "Apellido",
      "signup_email": "Correo Electrónico",
      "signup_password": "Contraseña"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: "es", // Forzamos español por defecto
    interpolation: { escapeValue: false }
  });

export default i18n;